import React from 'react';
import { useNavigate } from 'react-router-dom';

export function SelectPartnersModal({ onClose }) {
  const navigate = useNavigate();
  const displayScenarioCount = JSON.parse(localStorage.getItem('scenarios') || '[]').length;
  const socialScenarioCount = JSON.parse(localStorage.getItem('socialScenarios') || '[]').length;

  const partnerOptions = [
    {
      icon: "💬",
      title: "Social Partners",
      description: "Manage partners for social media campaigns",
      link: "/partners/social/optimize",
      inProgress: true,
      scenarioCount: socialScenarioCount
    },
    {
      icon: "🎥",
      title: "Video Partners",
      description: "Manage partners for video advertising"
    },
    {
      icon: "🖥️",
      title: "Direct Display Partners",
      description: "Manage partners for display advertising",
      link: "/partners/display",
      inProgress: true,
      scenarioCount: displayScenarioCount
    },
    {
      icon: "🔍",
      title: "Search Partners",
      description: "Manage partners for search advertising"
    },
  ];

  const handleOptionClick = (link) => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content partners-modal" onClick={e => e.stopPropagation()}>
        <h2>Select Partners for which Channel?</h2>
        <div className="options-grid modal-grid">
          {partnerOptions.map((option, index) => (
            <div 
              key={index} 
              className="option-card"
              onClick={() => handleOptionClick(option.link)}
            >
              {(option.inProgress || option.scenarioCount > 0) && (
                <div className="card-badges">
                  {option.inProgress && <span className="wip-badge">In Progress</span>}
                  {option.scenarioCount !== undefined && (
                    <span className="count-badge">Scenarios: {option.scenarioCount}</span>
                  )}
                </div>
              )}
              <div className="option-icon">
                {option.icon}
              </div>
              <div className="option-content">
                <h3 className="option-title">{option.title}</h3>
                <p className="option-description">{option.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
} 